export const FEDRAMP_PAGE_URL_SLUG = 'atlassian-government-cloud';
export const ISOLATED_CLOUD_PAGE_URL_SLUG = 'isolated-cloud';
